export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login/brand',
    REFRESH: '/auth/refresh',
    LOGOUT: '/auth/logout',
    RESET_PASSWORD: '/auth/password_reset/request/brand',
    VERIFY_OTP: '/auth/password_reset/verify',
    REQUEST_OTP: '/auth/brand_registration/request',
    BRAND_VERIFY: '/auth/brand_registration/verify',
    CREATE_NEW_PASSWORD: '/auth/password_reset/reset',
  },
  BRAND: {
    BASE: '/brands',
    REGISTER_STEP_ONE: '/brands/register_s1',
    REGISTER_STEP_TWO: '/brands/register_s2',
    LOGO_IMAGE: '/brands/logo_image',
    PASSWORD: '/brands/password',
  },
  CAMPAIGNS: {
    BASE: '/brands/campaigns',
    APPLICATIONS: (id: string | number) => `/brands/campaigns/${id}/applications`,
    ACCEPT_APPLICATION: (id: string | number) => `/brands/campaigns/applications/${id}/accept`,
    REJECT_APPLICATION: (id: string | number) => `/brands/campaigns/applications/${id}/reject`,
    STOP_CAMPAIGN: (id: string | number) => `/brands/campaigns/${id}/stop`,
  },
}
